import { DateInputLocalized } from '@components'

import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackAutomaticPaymentReminders } from '@features/invoicingSettings/modules/paymentsAndReminders'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'
import { UpsellOverlay } from '../../styles'
import * as Styled from './styles'

interface IssueDateProps {
  isLockedByUpsell: boolean
  openSubscriptionModal: () => void
}

export const IssueDate = ({ isLockedByUpsell, openSubscriptionModal }: IssueDateProps): ReactElement => {
  const { t } = useTranslation()
  const { trackAutomaticPaymentReminders } = useTrackAutomaticPaymentReminders()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Text weight="bold">
        {t('settings.organization.external_invoice.automatic_payment_reminders.issue_date.title')}
      </Text>
      <FormItem
        name="automaticPaymentRemindersSettings.activationDate"
        render={({ field: { onChange, ...rest } }) => {
          return (
            <Styled.DateInputWrapper>
              <DateInputLocalized
                {...rest}
                disabled={isLockedByUpsell}
                onChange={(date) => {
                  trackAutomaticPaymentReminders('Send reminders for invoices issued on or after clicked')
                  onChange(date)
                }}
              />
              {isLockedByUpsell && <UpsellOverlay onClick={openSubscriptionModal} />}
            </Styled.DateInputWrapper>
          )
        }}
      />
    </Flex>
  )
}
